var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestionBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7742 16.9038C17.746 15.2528 19 12.7728 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C10.9239 19 11.8153 18.8608 12.6543 18.6022C13.9433 19.7891 15.7684 20.2738 18 19.5C16.0067 19.1013 15.6027 18.067 15.7742 16.9038ZM10 16C10.5523 16 11 15.5523 11 15C11 14.4477 10.5523 14 10 14C9.44771 14 9 14.4477 9 15C9 15.5523 9.44771 16 10 16ZM11 13V12.3C11 11.6377 11.4678 11.1899 11.9904 10.6896C12.6514 10.0569 13.4 9.34035 13.4 8C13.4 6.6 12.4 5 9.99998 5C7.19998 5 6.59998 7.1 6.59998 8.5H8.49998C8.51385 8.45839 8.52772 8.39562 8.54479 8.31836C8.6508 7.83857 8.88028 6.8 9.99998 6.8C10.7 6.8 11.4 7.3 11.4 8.2C11.4 8.88387 10.8803 9.33679 10.3236 9.822C10.1477 9.97534 9.96807 10.1319 9.79998 10.3C9.09998 11 8.99998 11.8 8.99998 12.4V13H11Z",
    fill: "#647FB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionBubble);
export default __webpack_public_path__ + "static/media/icon-question-bubble.e8fa944b79d4db277dac08648091d563.svg";
export { ForwardRef as ReactComponent };